<div *ngIf="isLoading" class="overlay">
  <div class="spinner"></div>
</div>
<div class="container-fluid py-4">
  <div class="row justify-content-center">
    <div class="col-3 col-md-2" *ngFor="let card of resumenCards; index as i">
      <!-- [class]="i < 2 ? 'col-md-6' : 'col-md-4'" -->
      <div
        class="card card-stats"
        [ngClass]="{ 'card-stats__selected': i === 0 }"
        [routerLink]="card.route"
        [style.cursor]="card.route ? 'pointer' : 'default'"
      >
        <div class="card-body">
          <div class="row">
            <div class="col-12 col-md-6 col-lg-5">
              <div
                class="icon-big text-center text-dark rounded shadow"
                [ngClass]="card.bgClass"
              >
                <i [class]="card.icon"></i>
              </div>
            </div>
            <div class="col-7 d-flex flex-column justify-content-center">
              <p class="card-category mb-0">{{ card.label }}</p>
              <h4
                class="card-title mb-0"
                [ngClass]="{ 'text-dark': i === 0, 'text-white': i !== 0 }"
              >
                {{ card.value }}
              </h4>
            </div>
          </div>
        </div>
        <div class="card-footer">
          <div class="stats">
            <small [class]="i == 0 ? 'desc__selected' : 'desc'">{{
              card.desc
            }}</small>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="card">
    <div class="card-header">
      <div class="card-tools">
        <a
          *ngIf="!isPayroll"
          [routerLink]="['/numbers/accounting/quickbooks/expenses/add']"
          class="btn btn-dark btn-sm btn-new"
        >
          Add bill
        </a>
        <!-- <a
          *ngIf="isPayroll"
          [routerLink]="['/numbers/accounting/quickbooks/payrolls/add']"
          class="btn btn-dark btn-sm btn-new"
        >
          New payroll
        </a> -->
        <!-- <a
          [routerLink]="['/numbers/accounting/quickbooks/payrolls']"
          class="btn btn-dark btn-sm btn-new"
        >
          payrolls
        </a> -->
        <a [routerLink]="['/numbers/accounting']" class="btn btn-dark btn-sm btn-new">
          Staff
        </a>
        <a
          [routerLink]="['/numbers/accounting/freelancers']"
          class="btn btn-dark btn-sm btn-new"
        >
          Freelancers
        </a>
        <a
          [routerLink]="['/numbers/accounting/drivers']"
          class="btn btn-dark btn-sm btn-new"
        >
          Driver & +
        </a>
        <a
          [routerLink]="['/numbers/accounting/customers']"
          class="btn btn-dark btn-sm btn-new"
        >
          Customers
        </a>
        <a
          [routerLink]="['/numbers/accounting/quickbooks/expenses']"
          class="btn btn-dark btn-sm btn-selected"
        >
          Bills
        </a>
        <!-- <a
          [routerLink]="['/numbers/accounting/quickbooks/vendors']"
          class="btn btn-dark btn-sm btn-new"
        >
          v
        </a> -->
      </div>
    </div>
    <div class="card-body" *ngIf="step == 1">
      <div class="table-responsive">
        <table class="table table-bordered table-striped">
          <thead class="thead">
            <tr>
              <th *ngIf="isPayroll"><strong>Vendor</strong></th>
              <!-- <th><strong>Account</strong></th> -->
              <th><strong>Description</strong></th>
              <th><strong>Date</strong></th>
              <th><strong>Total</strong></th>
              <th><strong>Actions</strong></th>
            </tr>
          </thead>

          <tbody>
            <tr *ngFor="let item of data">
              <td *ngIf="isPayroll">{{ item?.EntityRef?.name || "N/A" }}</td>
              <!-- <td>{{ getAccounts(item?.Line) }}</td> -->
              <td>{{ getDescription(item?.Line) }}</td>
              <td>{{ item?.TxnDate }}</td>
              <td>{{ item?.TotalAmt }}</td>
              <td class="text-center">
                <a
                  [routerLink]="[
                    '/numbers/accounting/quickbooks/expenses/edit',
                    item.Id,
                    item.SyncToken
                  ]"
                  class="btn btn-link text-dark btn-sm p-2 btn-del"
                >
                  <i class="fas fa-edit"></i>
                </a>
                <button
                  (click)="deleteData(item.Id, item.SyncToken)"
                  class="btn btn-link text-dark btn-sm p-2 btn-del"
                >
                  <i class="fas fa-trash"></i>
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>
